export default {
    // API_URL: 'http://localhost:81/api',
    // SOCMED_API_URL: 'http://localhost:12020/api',
    API_URL: 'https://webstaticapi.omnicasa.com/api',
    SOCMED_API_URL: 'https://socmed-service.omnicasa.com/api'
};
